export default {
  brandColor1: '#5A2049',
  complimentaryColor1: '#fff',
  brandColor2: '#E51936',
  complimentaryColor2: '#fff',
};
